import { FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { BaseServiceService } from 'src/app/shared/services/base-service.service';
import { MensajesUsuario } from 'src/app/shared/enumeraciones/mensajes-usuario.enum';
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { ReporteProductividadService } from './reporte-productividad.service';
import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpEventType } from '@angular/common/http';
import { AuthService } from 'src/app/shared/services/auth.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-reporte-productividad',
  templateUrl: './reporte-productividad.component.html',
  styleUrls: ['./reporte-productividad.component.scss']
})
export class ReporteProductividadComponent implements OnInit {
  isCollapsed = true;
  isExportar = true;
  formFiltro: FormGroup;
  formExport: FormGroup;
  formArray = new FormArray([]);
  listCamaraComercio: Array<any>=[];
  listTipoSolicitud: Array<any>;
  listEstadoSolicitud: Array<any>;
  listEstadoRnt: Array<any>;
  listCategoria: Array<any>;
  listSubCategoria: Array<any>;
  listSubCategoriaFilter: Array<any>;
  listDepartamento: Array<any>;
  listDepartamentoFilter: Array<any>;
  listMunicipio: Array<any>;
  listMunicipioFilter: Array<any>;
  msgExport: string = MensajesUsuario.ExportExcel;
  columnToExport: string;
  totalChecked: number = 0;
  isDisabled: boolean = true;
  exportarList = [
    { id: "Descripcion_Camara", name: "Cámara de Comercio" },
    { id: "Descripcion_Tipo_Solicitud", name: "Tipo solicitud" },
    { id: "Descripcion_Estado_Solicitud", name: "Estado solicitud" },
    { id: "Fecha_Creacion", name: "Fecha creación" },
    { id: "Numero_Radicado", name: "Número radicación" },
    { id: "Fecha_Radicacion", name: "Fecha radicación" },
    { id: "Nombre_Funcionario", name: "Nombre completo del Funcionario"},
    { id: "Fecha_Ultima_Actualizacion", name: "Fecha última actualización" },
    { id: "Dias_Gestion", name: "Días en Gestión" },
    { id: "Codigo_Rnt", name: "Número RNT" },
    { id: "Descripcion_Estado_Rnt", name: "Estado RNT" },
    { id: "Descripcion_Categoria", name: "Categoría" },
    { id: "Descripcion_Subcategoria", name: "Subcategoría" },
    { id: "Matricula", name: "Número Matrícula" },
    { id: "Descripcion_Departamento", name: "Departamento"},
    { id: "Descripcion_Municipio", name: "Municipio"},
    { id: "Razon_Social", name: "Nombre o Razón social" },
    { id: "Nit", name: "Nit" },
    { id: "Nombre_Representante_Legal", name: "Nombre RL"},
    { id: "Numero_Identificacion_Representante_Legal", name: "Identificación RL"}
  ];
  // Datatable
  headerTabla: Array<string>;
  paginaActual: number;
  dataTabla: DatoPaginadoModel;
  // Filtros


  constructor(
    private reporteProductividadService: ReporteProductividadService,
    private baseService: BaseServiceService,
    private formBuilder: FormBuilder,
    private alertService: AlertsService,
    public authService: AuthService
  ) {
    this.paginaActual = 1;
    this.createPagingTable();
  }

  ngOnInit(): void {
    this.headerTabla = ['Cámara de comercio', 'Tipo de solicitud',
      'Estado de solicitud', 'Fecha Creación de solicitud', 'Número radicado',
      'Fecha de Radicación', 'Nombre completo del Funcionario', 'Fecha de última actualización',
      'Días en Gestión', 'Número RNT', 'Estado RNT', 'Categoría', 'Subcategoría', 'Matricula',
      'Departamento', 'Municipio', 'Nombre o Razón social', 'Nit', 'Nombre RL', 'Identificación RL'
    ];

    this.createForm();
    this.getCamaraComercio();
    this.getTipoSolicitud();
    this.getEstadoSolicitud();
    this.getEstadoRnt();
    this.getCategoria();
    this.getSubCategoria();
    // this.getDepartamento();
    // this.getMunicipio();
    this.onChanges();
    this.configureEventChangeForFilterForm();
  }

  createForm(){
    this.formFiltro = this.formBuilder.group({
      codigo_camara: [''],
      tipo_solicitud_id: [''],
      estado_solicitud_id: [''],
      numero_radicado: [''],
      funcionario: [''],
      codigo_rnt: [''],
      estado_rnt_id: [''],
      categoria_id: [''],
      sub_categoria_id: [''],
      matricula: [''],
      codigo_departamento: [''],
      codigo_municipio: [''],
      razon_social: [''],
      nit: ['']
    });

    // Form Export
    const selectAllControl = new FormControl(false);
    const formControl = this.exportarList.map(control => new FormControl(false));
    this.formExport = this.formBuilder.group({
      exportarList: new FormArray(formControl, this.minSelectCheckbox(1)),
      selectAll: selectAllControl
    });
  }
  minSelectCheckbox(min = 1) {
		const validator: ValidatorFn = (formArray: FormArray) => {
			const totalSelected = formArray.controls.map(control => control.value)
				.reduce((prev, next) => next ? prev + next : prev, 0);

			return totalSelected >= min ? null : { required: true };
		};
		return validator;
	}
  onChanges() {
		this.formExport.get('selectAll').valueChanges.subscribe(bool => {
			this.formExport
				.get('exportarList')
				.patchValue(Array(this.exportarList.length).fill(bool), { emitEvent: false });
		});
		this.formExport.get('exportarList').valueChanges.subscribe(val => {
			const allSelected = val.every(bool => bool);
			if (this.formExport.get('selecAll').value !== allSelected) {
				this.formExport.get('selectAll').patchValue(allSelected, { emitEvent: false });
			}
		});
	}
  checkboxValidate(){
    this.totalChecked = document.querySelectorAll('input[name=checkExport]:checked').length;

    if(this.totalChecked > 0){
      this.isDisabled = false;
    } else{
      this.isDisabled = true;
    }
  }

  createPagingTable(){
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.getDataReport(value);
  }

  filtrar() {
    this.paginaActual = 1;
    this.createPagingTable();
    this.getDataReport(1);
  }

  exportDataReport(){
    const selectedPreferences = this.formExport.value.exportarList
      .map((checked, index) => (checked ? this.exportarList[index].id : null))
      .filter((value) => value !== null);

    this.columnToExport = selectedPreferences.join();

    this.reporteProductividadService.reportProductivityExport({
      ...this.formFiltro.getRawValue(),
      columnas: this.columnToExport,
    }).subscribe((response) => {
      if (response.type === HttpEventType.Response) {
        if (response.ok) {
          const hoy = this.getDateToday();
          this.saveAsExcelFile(response.body, `${hoy}_reporte_productividad.xlsx`);
        }
      }
    });
  }

  private saveAsExcelFile(data: any, fileName: string): void {
    FileSaver.saveAs(data, fileName);
  }

  private getDateToday(): string {
    let fechaHoy = new Date().toLocaleDateString();
    while (fechaHoy.includes('/')) {
      fechaHoy = fechaHoy.replace('/', '-');
    }
    return fechaHoy;
  }

  getDataReport(page: number){
    let request = {
      ...this.formFiltro.getRawValue(),
      numeroPagina: page
    };

    this.reporteProductividadService.reportProductivityData(request).subscribe((response) => {
      if(response.result){
        if(response.data.items.length > 0){
          this.dataTabla = response.data as DatoPaginadoModel;
        } else{
          this.alertService.info(
            MensajesUsuario.NoDataFound,
            null,
            null
          );
        }
      } else{
        this.alertService.error(
          MensajesUsuario.Errorgeneral,
          null,
          null
        );
      }
    });
  }

  getCamaraComercio(){
    this.baseService.getCamaraComercio().subscribe((response) => {
      if(response.result){

        if(this.authService.getTipoUser()!=="1"){
				  let camaraUser=this.authService.getCamaraUser();
					let selectedCamara = response.data.find(option => option.codigo_camara === camaraUser);
					selectedCamara = selectedCamara as	Array<any>;
					this.listCamaraComercio.push(selectedCamara);
          this.formFiltro.get('codigo_camara').patchValue(camaraUser);
          this.formFiltro.get('codigo_camara').disable();
          this.getDepartamentosByCamaraComercio(camaraUser);
				}else{
					this.listCamaraComercio = response.data;
          this.getDepartamentosByCamaraComercio();
				}

      } else{
        this.alertService.error(
          MensajesUsuario.Errorgeneral,
          null,
          null
        );
      }
    });
  }

  getTipoSolicitud(){
    this.baseService.getTipoSolicitud().subscribe((response) => {
      if(response.result){
        this.listTipoSolicitud = response.data;
      } else{
        this.alertService.error(
          MensajesUsuario.Errorgeneral,
          null,
          null
        );
      }
    });
  }

  getEstadoSolicitud(){
    this.baseService.getEstadoSolicitud().subscribe((response) => {
      if(response.result){
        this.listEstadoSolicitud = response.data;
      } else{
        this.alertService.error(
          MensajesUsuario.Errorgeneral,
          null,
          null
        );
      }
    });
  }

  getEstadoRnt(){
    this.baseService.getEstadoRnt().subscribe((response) => {
      if(response.result){
        this.listEstadoRnt = response.data;
      } else{
        this.alertService.error(
          MensajesUsuario.Errorgeneral,
          null,
          null
        );
      }
    });
  }

  getCategoria(){
    this.baseService.getCategory().subscribe((response) => {
      if(response.result){
        this.listCategoria = response.data;
      } else{
        this.alertService.error(
          MensajesUsuario.Errorgeneral,
          null,
          null
        );
      }
    });
  }

  getSubCategoria(){
    this.baseService.getSubCategory().subscribe((response) => {
      if(response.result){
        this.listSubCategoria = response.data;
        this.listSubCategoriaFilter = response.data;
      } else{
        this.alertService.error(
          MensajesUsuario.Errorgeneral,
          null,
          null
        );
      }
    });
  }

  getDepartamento(){
    this.baseService.getDepartamento().subscribe((response) => {
      if(response.result){
        this.listDepartamento = response.data;
        this.listDepartamentoFilter = this.listDepartamento;
      } else{
        this.alertService.error(
          MensajesUsuario.Errorgeneral,
          null,
          null
        );
      }
    });
  }

  getMunicipio(){
    this.baseService.getMunicipio().subscribe((response) => {
      if(response.result){
        this.listMunicipio = response.data;
      } else{
        this.alertService.error(
          MensajesUsuario.Errorgeneral,
          null,
          null
        );
      }
    });
  }

  private configureEventChangeForFilterForm(): void {
    this.formFiltro.get('codigo_camara').valueChanges
    .subscribe(codigo_camara_selected => {
      this.getDepartamentosByCamaraComercio(codigo_camara_selected || "");
    });
    this.formFiltro.get('codigo_departamento').valueChanges
    .subscribe(departamento_selected => {
      const camara_selected = this.formFiltro.get('codigo_camara').value;
      this.getMunicipiosByCamaraComercioAndDepartamento(camara_selected || "", departamento_selected || "");
    })
    this.formFiltro.get('categoria_id').valueChanges
    .subscribe(categoria_id_selected => {
      this.listSubCategoriaFilter = [];
      this.formFiltro.get('sub_categoria_id').setValue('');
      if(categoria_id_selected) {
        this.listSubCategoriaFilter = this.listSubCategoria.filter(t => t.categoria_id == categoria_id_selected);
      }
    })
  }

  private getDepartamentosByCamaraComercio(codigo_camara: string = "") {
    this.listDepartamentoFilter = [];
    this.formFiltro.get('codigo_departamento').setValue('');
    this.baseService.getDepartamentosPorCamara({codigo_camara})
      .subscribe(response => {
        if (!response.result) {
          this.alertService.error(
            MensajesUsuario.Errorgeneral,
            null,
            null
          );
          return;
        }
        this.listDepartamentoFilter = response.data;
        this.getMunicipiosByCamaraComercioAndDepartamento(codigo_camara);
      })
  }

  private getMunicipiosByCamaraComercioAndDepartamento(codigo_camara:string, departamento_id:string = "") {
    this.listMunicipioFilter = [];
    this.formFiltro.get('codigo_municipio').setValue('');
    if(!departamento_id) return;
    this.baseService.getMunicipioPorCamara({ codigo_camara, departamento_id })
      .subscribe(response => {
        if (!response.result) {
          this.alertService.error(
            MensajesUsuario.Errorgeneral,
            null,
            null
          );
          return;
        }
        this.listMunicipioFilter = response.data;
      })
  }
}
